// src/auth/Login.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../api/auth.api"; // ✅ usamos el API actualizado
import { useAuthStore } from "../store/auth.store";

export default function Login() {
  const navigate = useNavigate();
  const loginStore = useAuthStore((s) => s.login);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      // ✅ Llamamos a loginUser que retorna { access_token, token_type, user }
      const data = await loginUser(username, password);

      // ✅ Guardamos token y usuario en el store
      loginStore(data.access_token, data.user);

      navigate("/dashboard", { replace: true });
    } catch (err) {
      console.error(err);
      setError(err.message || "Usuario o contraseña incorrectos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <h2 style={styles.title}>ERP / OLT Login</h2>

        {error && <p style={styles.error}>{error}</p>}

        <input
          style={styles.input}
          placeholder="Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button style={styles.button} disabled={loading}>
          {loading ? "Ingresando..." : "Ingresar"}
        </button>

        <div style={styles.version}>2026-v1.1-by-jeff</div>
      </form>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0f172a, #1e293b)",
  },
  form: {
    background: "#fff",
    padding: 32,
    borderRadius: 12,
    width: 360,
    maxWidth: "90%",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
  },
  title: {
    textAlign: "center",
    marginBottom: 12,
    color: "#0f172a",
  },
  input: {
    padding: "10px 12px",
    borderRadius: 6,
    border: "1px solid #cbd5e1",
    fontSize: 16,
    outline: "none",
  },
  button: {
    padding: "10px 12px",
    borderRadius: 6,
    border: "none",
    backgroundColor: "#2563eb",
    color: "#fff",
    fontSize: 16,
    cursor: "pointer",
    transition: "background-color 0.2s",
  },
  error: {
    color: "red",
    fontSize: 14,
    textAlign: "center",
  },
  version: {
    marginTop: 16,
    fontSize: 12,
    textAlign: "center",
    color: "#888",
  },
};
